module.exports = __webpack_public_path__ + "img/40.04f37019.png";